var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8729 9.61157C19.6942 9.36716 15.4371 3.62695 9.9999 3.62695C4.56274 3.62695 0.305391 9.36716 0.126914 9.61134C-0.0423048 9.84322 -0.0423048 10.1577 0.126914 10.3896C0.305391 10.634 4.56274 16.3742 9.9999 16.3742C15.4371 16.3742 19.6942 10.634 19.8729 10.3898C20.0423 10.1579 20.0423 9.84321 19.8729 9.61157ZM9.9999 15.0555C5.99486 15.0555 2.52606 11.2456 1.49922 10.0001C2.52473 8.75353 5.98626 4.94563 9.9999 4.94563C14.0048 4.94563 17.4733 8.75485 18.5006 10.001C17.4751 11.2476 14.0135 15.0555 9.9999 15.0555Z",
    fill: "#D83612"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.04297C7.81867 6.04297 6.04395 7.8177 6.04395 9.99903C6.04395 12.1804 7.81867 13.9551 10 13.9551C12.1813 13.9551 13.9561 12.1804 13.9561 9.99903C13.9561 7.8177 12.1813 6.04297 10 6.04297ZM10 12.6364C8.5457 12.6364 7.36266 11.4533 7.36266 9.99903C7.36266 8.54477 8.54574 7.36168 10 7.36168C11.4543 7.36168 12.6373 8.54477 12.6373 9.99903C12.6373 11.4533 11.4543 12.6364 10 12.6364Z",
    fill: "#D83612"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeRed);
export default __webpack_public_path__ + "static/media/eye-red.ec1422ac1a594cd6a38209449f53ab96.svg";
export { ForwardRef as ReactComponent };